import { useMembershipIds } from "hooks";

export const useIsFreeTrial = (membershipId?: string): boolean => {
  const {
    freeTrialMembershipId,
    freeTrialMembership30Id,
    freeTrialLimitlessMembership30Id,
    threeMonthFreeTrialMembershipId,
    thirtyDayFreeTrialMembershipId,
    thirtyDayFreeTrialRenewsToMonthlyMembershipId,
    sixtyDayFreeTrialRenewsToMonthlyMembershipId,
    sixtyDayFreeTrialRenewsToAnnualMembershipId,
    freeTrial14DayRenewsToStarter12M,
    freeTrial30DayRenewsToStarter12M
  } = useMembershipIds();

  if (!membershipId) return false;

  return [
    freeTrialMembershipId,
    freeTrialMembership30Id,
    freeTrialLimitlessMembership30Id,
    threeMonthFreeTrialMembershipId,
    thirtyDayFreeTrialMembershipId,
    thirtyDayFreeTrialRenewsToMonthlyMembershipId,
    sixtyDayFreeTrialRenewsToMonthlyMembershipId,
    sixtyDayFreeTrialRenewsToAnnualMembershipId,
    freeTrial14DayRenewsToStarter12M,
    freeTrial30DayRenewsToStarter12M
  ].includes(membershipId);
};

export const useRequireTermsConfirmation = (membershipId?: string): boolean => {
  const isFreeTrial = useIsFreeTrial(membershipId);
  const {
    threeMonthPaidRenewsAnnuallyId,
    annualLimitlessMembershipId,
    annualLiteMembership
  } = useMembershipIds();

  return (
    isFreeTrial ||
    membershipId === threeMonthPaidRenewsAnnuallyId ||
    membershipId === annualLiteMembership ||
    // Annual Limitless Membership Id is the standard plus annual membership
    membershipId === annualLimitlessMembershipId
  );
};
